import React, { useState, useEffect } from 'react';
import {
  Spinner,
  Modal,
  Button,
  Row,
  Col,
  Form,
} from '@themesberg/react-bootstrap';
import MUIDataTable from 'mui-datatables';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { useSelector, useDispatch } from 'react-redux';
import { assignToCollector, getCustomer } from '../../redux/actions/customer';
import { tableThemeCheckbox } from '../../helpers/tableTheme';
import CustomDashboardLoader from '../../components/CustomDashboardLoader';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
import CollectorHelper from '../../helpers/CollectorHelper';
import { getCollectors } from '../../redux/actions/collector';
import toast from 'react-hot-toast';

const columns = [
  {
    name: 'Customer Id',
    label: 'Customer Id',
    options: {
      filter: false,
      sort: false,
    },
  },
  {
    name: 'Name',
    label: 'Name',
    options: {
      filter: false,
      sort: true,
    },
  },
  {
    name: 'Location',
    label: 'Location',
    options: {
      filter: false,
      sort: false,
    },
  },
  {
    name: 'Phone Number',
    label: 'Phone Number',
    options: {
      filter: false,
      sort: false,
    },
  },
  {
    name: 'Business Type',
    label: 'Business Type',
    options: {
      filter: false,
      sort: false,
    },
  },
  {
    name: 'Collector Id',
    label: 'Collector Id',
    options: {
      filter: false,
      sort: false,
      display: "excluded",
    },
  },
  'Assigned Collector',
  {
    name: 'Collector Number',
    label: 'Collector Number',
    options: {
      filter: false,
      sort: false,
    },
  },
];

function BatchAssignCustomer({ history }) {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isCollectorLoading, setIsCollectorLoading] = useState(false);
  const [changedCollectorData, setChangedCollectorData] = useState([]);
  const [collectorVal, setCollectorVal] = useState(null);

  const [customerIdList, setCustomerIdList] = useState();
  const handleCloseModal = () => setShowModal(false);
  const handleShowModal = () => setShowModal(true);

  const customerData = useSelector((state) => state.customer.customerData);
  const collectorData = useSelector((state) => state.collector.collectorData);

  useEffect(() => {
    setIsLoading(true);
    setIsCollectorLoading(true);
    dispatch(getCustomer()).then(() => setIsLoading(false));
    dispatch(getCollectors(true)).then(() => setIsCollectorLoading(false));
  }, []);
  useEffect(() => {
    const tempArr = CollectorHelper(collectorData);
    setChangedCollectorData(tempArr);
  }, [collectorData]);

  //   const onRowsSelect = (rowData, rowMeta) => {
  //     history.push(`/customers/profile/${rowData[0]}`);
  //   };
  const options = {
    filterType: 'checkbox',
    selectableRowsOnClick: true,
    responsive: 'standard',
    print: false,
    download: false,
    elevation:0,
    customToolbarSelect: (selectedRows, displayData, setSelectedRows) => {
      return (
        <div className='d-flex'>
          <div style={{ marginRight: '2rem' }}>
            <Button
              variant='danger'
              onClick={() => setSelectedRows([])}
              disabled={isSubmitting}
            >
              Cancel
            </Button>
            {/* <FontAwesomeIcon icon={faTimes} /> */}
          </div>
          <div style={{ marginRight: '2rem' }}>
            <Button
              variant='primary'
              onClick={() =>
                tickHandler(selectedRows, displayData, setSelectedRows)
              }
              disabled={isSubmitting}
            >
              Assign a Collector
            </Button>
            {/* <FontAwesomeIcon icon={faCheck} style={{ marginLeft: "1rem" }} /> */}
          </div>
        </div>
      );
    },
  };

  const tickHandler = (selectedRows, displayData, setSelectedRows) => {
    const selectedIndexArr = selectedRows.data.map((item) => item.dataIndex);
    const filteredData = displayData.filter((each) =>
      selectedIndexArr.includes(each.dataIndex)
    );
    const customerIdListArr = filteredData.map((item) => {
      return item.data[0];
    });
    setCustomerIdList(customerIdListArr);
    handleShowModal();
  };

  const handleSuccess = () => {
    setIsLoading(true);
    handleCloseModal();
    dispatch(getCustomer()).then(() => setIsLoading(false));
  };

  const submitHandler = () => {
    if (!collectorVal) {
      toast.error('Please select a collector');
    } else {
      setIsSubmitting(true);
      const data = {
        collectorId: collectorVal,
        customerIdList,
      };
      dispatch(assignToCollector(data, handleSuccess)).then(() =>
        setIsSubmitting(false)
      );
    }

    // alert(JSON.stringify(customerIdList));
  };

  return (
    <div>
      <MuiThemeProvider theme={tableThemeCheckbox}>
        {isLoading ? (
          <CustomDashboardLoader />
        ) : (
          <>
            {/* Modal Here */}
            <Modal show={showModal} onHide={handleCloseModal} centered>
              <Modal.Header closeButton>
                <Modal.Title>Batch Assign Collectors</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Row>
                  <Col md={12} className='mb-3'>
                    <Form.Group className='mb-3'>
                      <Form.Label>
                        Do you want to all the selected customers this
                        collector?
                      </Form.Label>
                      {!isCollectorLoading && (
                        <Form.Select
                          aria-label='Select a collector'
                          value={collectorVal}
                          onChange={(e) => setCollectorVal(e.target.value)}
                        >
                          <option value={null}>{null}</option>
                          {changedCollectorData.map((item) => (
                            <option
                              value={item.customerId}
                              key={item.customerId}
                            >
                              {item.name} - ({item.username})
                            </option>
                          ))}
                        </Form.Select>
                      )}
                    </Form.Group>
                  </Col>
                </Row>
              </Modal.Body>
              <Modal.Footer>
                <Button variant='danger' onClick={handleCloseModal}>
                  Cancel
                </Button>
                <Button
                  variant='primary'
                  onClick={submitHandler}
                  disabled={isSubmitting}
                >
                  {isSubmitting === true ? (
                    <Spinner animation='border' />
                  ) : (
                    'Submit'
                  )}
                </Button>
              </Modal.Footer>
            </Modal>

            {/* Table here */}

            <MUIDataTable
              title={'Assign Collectors to Customers (Batch)'}
              data={customerData}
              columns={columns}
              options={options}
            />
          </>
        )}
      </MuiThemeProvider>
    </div>
  );
}

export default BatchAssignCustomer;
